<template>
  <!-- w-32 h-31 -->
  <path d='M27 7H12' stroke='white' stroke-width='2' stroke-linecap='round' />
  <path d='M4.00003 7H5.00003' stroke='white' stroke-width='2' stroke-linecap='round' />
  <path d='M27 16H12' stroke='white' stroke-width='2' stroke-linecap='round' />
  <path d='M4.00003 16H5.00003' stroke='white' stroke-width='2' stroke-linecap='round' />
  <path d='M27 25H12' stroke='white' stroke-width='2' stroke-linecap='round' />
  <path d='M4.00003 25H5.00003' stroke='white' stroke-width='2' stroke-linecap='round' />
</template>
